import React, { useEffect, useState } from 'react'
import { makeStyles } from '@material-ui/core/styles';
import { useTheme } from '@mui/material';
import { TextField, Checkbox, Button, Alert, Snackbar  } from '@mui/material'
import axios from 'axios'
import { useLocation, useNavigate } from 'react-router-dom';
import { TbLoader } from 'react-icons/tb';

const useStyles = makeStyles((theme)=>({

  box:{
    maxWidth:'1800px',
    margin:'0 auto',
    padding:'0 20px',

    fontFamily:[
      'Noto Sans KR'
    ],
  },
  groupEditBlockH1:{
    padding:'40px 0 20px 0px',
    fontWeight:'700',
    fontSize:'22px',
  },
  innerDiv:{
    margin:'20px 0',
    display:'flex',
    alignItems:'center',
    paddingBottom:'20px',
    borderBottom:'1px solid #e2e2e2',

    [theme.breakpoints.down(1025)]: {
      flexDirection:'column',
    }
  },
  spanSpan:{
    fontSize:'18px',
    fontWeight:'500',
    width:'100px',

    [theme.breakpoints.down(1025)]: {
      marginBottom:'10px',
      textAlign:'center'
    }
  },
  btnDiv:{
    display:'flex',    
    marginTop:'30px',

    [theme.breakpoints.down(1025)]: {
      justifyContent:'center',
    }
  },
  firstbtnDiv:{
    paddingRight:'20px',
  },
  load:{
    display:'flex',
    justifyContent:'center',
    alignItems:'center',
  },
  loadingIcon:{
    color:'#007235',
    fontSize:'50px',
    animation:'$loadSpin 5s infinite'
  },
  "@keyframes loadSpin":{
    from: { transform:'rotate(0deg)' },
    to: { transform:'rotate(1turn)' }
  },

}));

const GroupEdit = () => {
  const theme = useTheme();
  const classes = useStyles(theme);
  const location = useLocation();
  let navigate = useNavigate();
  const [errSnack, setErrSnack] = useState(false);
  const [succSnack, setSuccSnack] = useState(false);

  const [caId, setCaId] = useState('');
  const [caName, setCaName] = useState('');
  const [caUse, setCaUse] = useState(0);
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    window.scrollTo(0, 0);

    return () => {
      setCaId('')
      setCaName('')
      setCaUse(0)
    }
  }, [])

  const getItem = async() => {
    try {
      setLoading(true)
      const res = await axios.post('/api/adm/categoryConfigEditPageView/', {ca_id: location.state.ca_id})

      if(res.data.success === false) {
        setErrSnack(true)
        setLoading(false)
        return ;
      }

      const result = res.data.result
      
      setCaId(result['ca_id'])
      setCaName(result['ca_name'])
      setCaUse(result['ca_use'])
      setLoading(false)
  
    } catch (e) {
      setErrSnack(true)
      setLoading(false)
      console.log(e)
    }
  } 

  useEffect(() => {
    if(location.state.ca_id){
      getItem()
    }
  } , [location.state.ca_id])


  const addItem = async() => {
    if (caName === '') return ;

    try {
      const res = await axios.post('/api/adm/categoryConfigEditView/', 
                                    {ca_id: caId, ca_name: caName, ca_use: caUse}
      )

      if(res.data.success === false) {
        setErrSnack(true)
        return ;
      }
      getItem();
      
    } catch (e) {
      setErrSnack(true)
      console.log(e)
    }

  }





  const snackClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setErrSnack(false);
    setSuccSnack(false)
  };

  return (
    <div className={classes.groupEditBlock}>
      {loading ? (
        <div className={classes.load}>
          <TbLoader className={classes.loadingIcon}/>
        </div>
      ) :(
        <>
        <div className={classes.box}>
        <h1 className={classes.groupEditBlockH1}>분류 수정</h1>
        <div className={classes.innerDiv}>
          <span className={classes.spanSpan}>분류코드</span>
          {caId}
        </div>
        <div className={classes.innerDiv}>
          <span className={classes.spanSpan}>분류명</span>
          <TextField 
            sx={{ width: '250px' }}
            hiddenlabel="true" 
            variant="outlined" 
            value={caName}
            onChange={(e) => {setCaName(e.target.value)}}
          />
        </div>
        <div className={classes.innerDiv}>
          <span className={classes.spanSpan}>판매가능</span>
          <Checkbox
            checked={caUse === 0 ? false : true}
            onChange={() => {
              caUse === 0 ?
              setCaUse(1) : 
              setCaUse(0)
            }}
          />
        </div>
  
        <div className={classes.btnDiv}>
          <div className={classes.firstbtnDiv}>
            <Button 
              variant="outlined"
              onClick={() => addItem()}
            >
              확인
            </Button>
          </div>
          <div>
            <Button 
              variant="outlined"
              onClick={() => {
                navigate("/DashboardMain/itemGroupConfig");
              }}
            >
              목록
            </Button>
          </div>
        </div>
      </div>



      <Snackbar 
        open={errSnack} 
        autoHideDuration={6000} 
        onClose={snackClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}                          
      >
        <Alert severity="error">수행을 실패 하였습니다!</Alert>
      </Snackbar>
      <Snackbar 
        open={succSnack} 
        autoHideDuration={6000} 
        onClose={snackClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}                          
      >
        <Alert severity="success">수행을 성공 하였습니다!</Alert>
      </Snackbar>         
      </>
      )}
      

    </div>
  )
}

export default GroupEdit
